import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime,
    DialogSize,
    RaikoBaseCardContainer, RaikoButtonPrimary,
    RaikoCollapsibleTable,
    RaikoCustomSelect, raikoCustomSelectItemGenerator,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage, RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoMaterialOutlinedInput,
    RaikoTableTitleContainer,
    showErrorMessage, showSuccessMessage, showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {FundService} from "../../../serverService/fund/FundService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import React, {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {GatewayTypes} from "../../../util/GatewayTypes";
import FundDetailGatewayDetail from "./FundDetailGatewayDetail";
import {css} from "@emotion/css";

export default function FundDetailGateway() {

    const size = 25
    let page = 0

    const {id: fundId = -1} = useParams()
    const service = new FundService()

    useEffect(() => {
        getDataFromServer()
    }, []);


    const loading = new LoadingHelper(useLoadingDispatcher())

    const [gateways, setGateways] = useState([])
    const [tableLoading, setTableLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0)

    function handleChangePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    function prepareNewRow(id, number, title, type, createdAt, createdBy, enabled, fundId) {
        return {
            id,
            number,
            title,
            type: GatewayTypes[type].name,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            enabled: <RaikoCustomSimpleActiveDeActiveChip
                state={enabled}
                deActiveStateTitle={"غیرفعال"}
                activeStateTitle={"فعال"}/>,
            children: <FundDetailGatewayDetail id={id}/>
        }
    }

    function getDataFromServer() {
        setTableLoading(true)
        service.getFundGatewayList(fundId, page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setGateways([])
                setTotalAmount(response.numberOfItems)
                response.data.map((item, index) => {
                    setGateways(prev => [
                        ...prev,
                        prepareNewRow(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.type,
                            item.createdAt,
                            item.createdBy,
                            item.enabled,
                            item.fundId
                        )
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }

    const [dialogOpenState, setDialogOpenState] = useState(false);
    const openDialog = () => setDialogOpenState(true)
    const closeDialog = () => setDialogOpenState(false)

    const [gatewayTitle, setGatewayTitle] = useState("");
    const [gatewayType, setGatewayType] = useState(GatewayTypes.ZARINPAL.id);


    function handleCreateGateway() {
        if (gatewayTitle && gatewayTitle.length > 0) {
            loading.show()
            service.createNewGateway(fundId, gatewayTitle, gatewayType)
                .then(response => {
                    showSuccessMessage("درگاه جدید با موفقیت افزوده شد.")
                    handleAddNewItemToTable(response)
                }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        } else {
            showWarningMessage("لطفا نام درگاه را وارد نمایید.")
        }
    }

    function handleAddNewItemToTable(item) {
        const gatewaysItems = addNewRowToTable(
            prepareNewRow(
                item.id,
                1,
                item.title,
                item.type,
                item.createdAt,
                item.createdBy,
                item.enabled,
                0
            ),
            gateways
        )

        setGateways(gatewaysItems)
        closeDialog()
    }

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={closeDialog}
                open={dialogOpenState}
                pageTitle={"درگاه پرداخت جدید"}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem;`}>
                    <RaikoMaterialOutlinedInput
                        labelText={"نام درگاه"}
                        value={gatewayTitle}
                        setValue={setGatewayTitle}
                    />
                    <RaikoCustomSelect
                        labelText={"نوع درگاه"}
                        value={gatewayType}
                        setValue={setGatewayType}
                        items={[
                            raikoCustomSelectItemGenerator(GatewayTypes.ZARINPAL.id, GatewayTypes.ZARINPAL.name),
                            raikoCustomSelectItemGenerator(GatewayTypes.NEXTPAY.id, GatewayTypes.NEXTPAY.name),
                            raikoCustomSelectItemGenerator(GatewayTypes.PERSIAN_BANK.id, GatewayTypes.PERSIAN_BANK.name),
                        ]}
                    />

                    <RaikoFlexAlignEnd>
                        <RaikoButtonPrimary
                            label={"افزودن"}
                            onClick={handleCreateGateway}
                        />
                    </RaikoFlexAlignEnd>
                </RaikoGridOneColumn>
            </RaikoDefaultDialogPage>
            <RaikoGridOneColumn>
                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"درگاه پرداخت"}
                            amount={totalAmount}
                            hasAmount
                            hasCreateNewItem
                            handleCreateNewItem={openDialog}/>

                        <RaikoCollapsibleTable
                            header={header}
                            data={gateways}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            isLoading={tableLoading}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoGridOneColumn>

        </>
    )
}


const header = [
    {
        id: 'number',
        label: '#',
    }, {
        id: 'title',
        label: 'نام درگاه',
    }, {
        id: 'type',
        label: 'نوع درگاه',
    }, {
        id: 'createdBy',
        label: 'سازنده',
    }, {
        id: 'createdAt',
        label: 'تاریخ ساخت',
    }, {
        id: 'enabled',
        label: 'وضعیت',
    },
]
